var map = {
	"./1left.png": "YgvV",
	"./2left.png": "JlQ/",
	"./3left.png": "hd4X",
	"./4left.png": "8I/Q",
	"./5left.png": "PNTx",
	"./6left.png": "rRv6",
	"./7left.png": "Q5qn"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0MqZ";